import React from 'react';
import SubstanceCompositionList from './SubstanceCompositionList';

const SubstanceCompositionTab = props => <SubstanceCompositionList {...props} />;

export default SubstanceCompositionTab;
